var _defs, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgArrowTop = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.023,
    height: 8.51,
    viewBox: "0 0 14.023 8.51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.123,131.779l-6.241-6.241a.771.771,0,0,1,0-1.09l.728-.728a.771.771,0,0,1,1.089,0l4.969,4.946,4.969-4.946a.771.771,0,0,1,1.089,0l.728.728a.771.771,0,0,1,0,1.09l-6.241,6.241a.771.771,0,0,1-1.09,0Z",
    transform: "translate(19.679 132.005) rotate(180)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowTop, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-top.8ce0b044.svg";
export { ForwardRef as ReactComponent };